export function getCookie(key) {
    const cookie = document.cookie.split("; ").find((row) => row.startsWith(key));

    return cookie?.split("=")[1];
}